import React from 'react';
import { useTranslation } from 'react-i18next';
import { Recommendation } from './interfaces/recomendation';
import arrowImage from './images/arrow.svg';
import css from './index.module.css';

const INDEX_DISPLAY_PRECISION = 1;

interface Props {
  index: number;
  recommendation: Recommendation;
}

export default function Details({ index, recommendation }: Props) {
  const { t } = useTranslation();
  const multiplier = Math.pow(10, INDEX_DISPLAY_PRECISION);
  const indexValue = (Math.floor(index * multiplier) / multiplier).toFixed(
    INDEX_DISPLAY_PRECISION
  );

  return (
    <div className={css['tab-content']}>
      <div
        className={css['index']}
        data-name={recommendation?.tabKey + '-recommendations'}
      >
        <strong>{t('pages.dashboard.heat_stress_index.heading')}</strong>

        {recommendation?.icon && (
          <div className={css['icon']}>
            <img alt="" src={recommendation.icon} />
          </div>
        )}

        <div
          className={`${css['value']} ${css[recommendation?.risk]}`}
          data-name="heat-stress-index-value"
        >
          {indexValue}
        </div>
      </div>

      <div className={css['delimiter']}>
        <div className={css['line']} />
        <img alt="" src={arrowImage} />
      </div>

      <div className={css['description']}>
        <div>
          <strong>{t('pages.dashboard.heat_stress_index.tabs.signs')}</strong>
          {recommendation?.signs}
        </div>
        <div>
          <strong>{t('pages.dashboard.heat_stress_index.tabs.impact')}</strong>
          {recommendation?.impact}
        </div>
        <div>
          <strong>
            {t('pages.dashboard.heat_stress_index.tabs.recommendation')}
          </strong>
          {recommendation?.recommendation}
        </div>
      </div>
    </div>
  );
}
